import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import countryData from "../../data/countries.json";
import "./Navbar.css";
import logo from "../../assets/logo-new.png";
import dropdownIcon from "../../assets/dropdown.svg";
// Updated: use Instagram icon instead of Facebook
import instaIcon from "../../assets/icons/insta.svg";
import liIcon from "../../assets/icons/linkedin.svg";
import mailIcon from "../../assets/icons/gmail.svg";
import { useInquiry } from "../../context/InquiryContext";

function Navbar() {
  const [countries, setCountries] = useState([]);
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [chinaOpen, setChinaOpen] = useState(false);
  const [thailandOpen, setThailandOpen] = useState(false);
  const navigate = useNavigate();
  const { count } = useInquiry();

  useEffect(() => {
    const filtered = countryData.filter(
      (country) => country.country === "China" || country.country === "Thailand"
    );
    setCountries(filtered);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  const handleCategoryClick = (country, category) => {
    navigate("/products", {
      state: {
        country: country.country,
        category: category.name,
        products: category.products || [],
      },
    });
    closeSidebar();
  };

  return (
    <>
      <nav className="navbar">
        {/* Logo */}
        <div className="navbar-left">
          <Link to="/" aria-label="Home">
            <img src={logo} alt="Logo" className="navbar-logo" />
          </Link>
        </div>

        {/* Hamburger */}
        <button
          className="hamburger"
          onClick={toggleSidebar}
          aria-label={isSidebarOpen ? "Close menu" : "Open menu"}
          aria-expanded={isSidebarOpen}
        >
          ☰
        </button>

        {/* Links */}
        <ul className="navbar-list">
          <li>
            <Link className="navbar-item" to="/">
              Home
            </Link>
          </li>

          {countries.map((country, idx) => (
            <li
              key={idx}
              className="navbar-item dropdown"
              style={{ position: "relative" }}
            >
              <Link
                to={`/${country.country.toLowerCase()}`}
                className="dropbtn"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                {country.country} Products
                <img
                  src={dropdownIcon}
                  alt="Dropdown"
                  className="dropdown-icon"
                />
              </Link>

              <div className="dropdown-content" role="menu" aria-label={`${country.country} categories`}>
                {country.categories.map((cat, i) => (
                  <div
                    key={i}
                    className="nav-item-link"
                    onClick={() => handleCategoryClick(country, cat)}
                    role="menuitem"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") handleCategoryClick(country, cat);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    {cat.name}
                  </div>
                ))}
              </div>
            </li>
          ))}

          <li>
            <Link className="navbar-item" to="/chemical">
              Chemical
            </Link>
          </li>
          <li>
            <Link className="navbar-item" to="/about">
              About Us
            </Link>
          </li>
          <li>
            <Link className="navbar-item" to="/faq">
              FAQ
            </Link>
          </li>
          <li>
            <Link className="navbar-item" to="/contact">
              Contact Us
            </Link>
          </li>

          {/* Inquiry Link with badge (top nav) */}
          <li>
            <Link className="navbar-item nav-inquiry-link" to="/inquiry" title="Your inquiry list">
              Inquiry
              {count > 0 && <span className="inquiry-badge" aria-hidden="true">{count}</span>}
            </Link>
          </li>
        </ul>

        {/* Social Icons */}
        <div className="social-icons">
          {/* Replaced Facebook with Instagram - update the href to your real profile */}
          <a
            href="https://www.instagram.com/newbell_yiwu"
            className="icon"
            target="_blank"
            rel="noopener noreferrer"
            title="Instagram"
            aria-label="Instagram"
          >
            <img src={instaIcon} alt="Instagram" />
          </a>
          <a
            href="https://www.linkedin.com/in/newbell-international-exports-70b3a4263/"
            className="icon"
            target="_blank"
            rel="noreferrer"
            title="LinkedIn"
          >
            <img src={liIcon} alt="LinkedIn" />
          </a>
          <a
            href="mailto:exports@newbell.net"
            className="icon"
            title="Email"
          >
            <img src={mailIcon} alt="Email" />
          </a>
        </div>
      </nav>

      {/* Sidebar */}
      <div className={`sidebar ${isSidebarOpen ? "active" : ""}`} role="dialog" aria-modal={isSidebarOpen}>
        <div className="sidebar-header">
          <Link to="/" onClick={closeSidebar}>
            <img src={logo} alt="Logo" className="sidebar-logo" />
          </Link>
          <button className="close-btn" onClick={() => closeSidebar()} aria-label="Close sidebar">
            &times;
          </button>
        </div>
        <Link to="/" onClick={closeSidebar}>Home</Link>

        {/* China Dropdown */}
        <div className="sidebar-dropdown">
          <div className="sidebar-dropdown-header">
            <Link to="/china" className="sidebar-dropdown-link" onClick={closeSidebar}>
              China Products
            </Link>
            <button
              className="dropdown-toggle"
              onClick={() => setChinaOpen(!chinaOpen)}
              aria-expanded={chinaOpen}
              aria-controls="china-categories"
            >
              {chinaOpen ? "▲" : "▼"}
            </button>
          </div>
          {chinaOpen &&
            countries
              .find((c) => c.country === "China")
              ?.categories.map((cat, i) => (
                <div
                  key={`china-${i}`}
                  onClick={() => {
                    handleCategoryClick(countries.find((c) => c.country === "China"), cat);
                  }}
                  className="sidebar-subitem"
                  style={{ cursor: "pointer" }}
                >
                  {cat.name}
                </div>
              ))}
        </div>

        {/* Thailand Dropdown */}
        <div className="sidebar-dropdown">
          <div className="sidebar-dropdown-header">
            <Link to="/thailand" className="sidebar-dropdown-link" onClick={closeSidebar}>
              Thailand Products
            </Link>
            <button
              className="dropdown-toggle"
              onClick={() => setThailandOpen(!thailandOpen)}
              aria-expanded={thailandOpen}
              aria-controls="thailand-categories"
            >
              {thailandOpen ? "▲" : "▼"}
            </button>
          </div>
          {thailandOpen &&
            countries
              .find((c) => c.country === "Thailand")
              ?.categories.map((cat, i) => (
                <div
                  key={`thailand-${i}`}
                  onClick={() => {
                    handleCategoryClick(countries.find((c) => c.country === "Thailand"), cat);
                  }}
                  className="sidebar-subitem"
                  style={{ cursor: "pointer" }}
                >
                  {cat.name}
                </div>
              ))}
        </div>

        <Link to="/chemical" onClick={closeSidebar}>Chemical</Link>
        <Link to="/about" onClick={closeSidebar}>About Us</Link>
        <Link to="/faq" onClick={closeSidebar}>FAQ</Link>
        <Link to="/contact" onClick={closeSidebar}>Contact Us</Link>

        {/* Inquiry link in the sidebar (shows same badge) */}
        <Link to="/inquiry" className="sidebar-inquiry-link" onClick={closeSidebar}>
          Inquiry
          {count > 0 && <span className="inquiry-badge sidebar-badge" aria-hidden="true">{count}</span>}
        </Link>
      </div>

      {/* Overlay covering the page when sidebar is active */}
      {isSidebarOpen && (
        <div className="sidebar-overlay" onClick={closeSidebar} />
      )}
    </>
  );
}

export default Navbar;